<template>
    <div>
        <div class="row q-col-gutter-sm">
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <q-select
                    v-model="emailTemplate"
                    outlined
                    :options="templates"
                    label="Template"
                    option-value="name"
                    option-label="label"
                    emit-value
                    map-options
                    color="input-color"
                    @input="updateTemplate"
                />
            </div> <!-- Email Template -->
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <q-input
                    v-model="content.email"
                    label="To"
                    readonly
                    color="input-color"
                />
            </div><!-- TO -->
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4">
                <q-select
                    v-model="emailObj.category"
                    outlined
                    :options="categories"
                    label="Category"
                    option-value="value"
                    option-label="label"
                    emit-value
                    map-options
                    color="input-color"
                    :readonly="emailObj.template !== 'blank'"
                />
            </div> <!-- Category -->
            <div class="col-xs-12 col-sm-12 col-md-8 col-lg-8">
                <q-input
                    v-model="emailObj.subject"
                    label="Subject"
                    :error="emailObj.errors.has('subject')"
                    :error-message="emailObj.errors.get('subject')"
                    lazy-rules
                    :rules="[ val => !!val || 'Subject is required']"
                    color="input-color"
                />
            </div><!-- Subject -->
            <div class="col-12">
                <q-editor
                    v-model="emailObj.body"
                    ref="editor"
                    :dense="$q.screen.lt.md"
                    color="input-color"
                    :toolbar="[
                        ['fields'],
                        [
                            {
                              label: $q.lang.editor.align,
                              icon: $q.iconSet.editor.align,
                              fixedLabel: true,
                              options: ['left', 'center', 'right', 'justify']
                            }
                        ],
                        ['bold', 'italic', 'strike', 'underline'],
                        ['hr', 'link'],
                        ['foreColor', 'backColor'],
                        ['unordered', 'ordered'],
                        ['removeFormat', 'viewsource'],
                        ['undo', 'redo']
                    ]"
                >
                    <template v-slot:foreColor>
                        <q-btn
                            flat
                            no-caps
                            dense
                            style="font-size: 0.7em"
                            icon="fa fa-palette"
                        >
                            <q-tooltip>Fore color</q-tooltip>
                            <q-menu anchor="top left" self="top left">
                                <q-color v-model="foreColor" class="my-picker"></q-color>
                                <q-btn
                                    color="primary"
                                    style="width: 200px"
                                    label="Select"
                                    @click="color('foreColor', foreColor)"
                                />
                            </q-menu>
                        </q-btn>
                    </template>
                    <template v-slot:backColor>
                        <q-btn
                            flat
                            dense
                            no-caps
                            style="font-size: 0.7em"
                            icon="format_paint"
                        >
                            <q-tooltip>Back color</q-tooltip>
                            <q-menu anchor="top left" self="top left">
                                <q-color v-model="backColor" class="my-picker"></q-color>
                                <q-btn
                                    color="primary"
                                    style="width: 200px"
                                    label="Select"
                                    @click="color('backColor', backColor)"
                                />
                            </q-menu>
                        </q-btn>
                    </template>
                    <template v-slot:fields>
                        <q-btn-dropdown
                            dense no-caps
                            ref="token"
                            no-wrap
                            unelevated
                            label="Fields"
                            size="sm"
                        >
                            <q-list dense>
                                <q-item tag="label" clickable @click="add(field)" v-for="field in fields" :key="field.value">
                                    <q-item-section>{{ field.label }}</q-item-section>
                                </q-item>
                            </q-list>
                        </q-btn-dropdown>
                    </template>
                    <template v-slot:error>
                        {{ emailObj.errors.get('body') }}
                    </template>
                </q-editor>
            </div><!-- Body -->
        </div>
    </div>
</template>
<script>

import {EmailTemplatesMixin} from "./EmailTemplatesMixin"
export default {
    name: "EmailForm",
    mixins: [ EmailTemplatesMixin ],
    model: {
        prop: 'emailObj',
        event: 'change'
    },
    props: {
        emailObj: {
            type: Object,
            required: true
        },
        content: {
            type: Object,
            required: true
        }
    },
    computed: {},
    data() {
        return {
            emailTemplate: 'kyc_incomplete_1',
            innerLoading: false,
            foreColor: '',
            backColor: '',
            fields: [
                {label: 'Id', value: this.content.id},
                {label: 'First name', value: this.content.first_name},
                {label: 'Middle name', value: this.content.middle_name},
                {label: 'Last name', value: this.content.last_name},
                {label: 'Email', value: this.content.email},
                {label: 'Address', value: this.content.address},
                {label: 'Identity', value: this.content.identity},
                {label: 'ECDD', value: this.content.edcc},
                {label: 'Ref code', value: this.content.ref_code},
                {label: 'Reference', value: this.content.reference},
                {label: 'Registered at', value: this.content.registered_at},
            ],
            categories: [
                {label: 'Compulsory', value: 'compulsory'},
                {label: 'News', value: 'news'},
                {label: 'Offers', value: 'offers'},
                {label: 'Rates', value: 'rates'},
                {label: 'Reminders', value: 'reminders'},
            ],
        }
    },
    methods: {
        color (cmd, name) {
            const edit = this.$refs.editor
            edit.caret.restore()
            edit.runCmd(cmd, name, true)
            edit.focus()
        },
        add(field) {
            const edit = this.$refs.editor
            this.$refs.token.hide()
            edit.caret.restore()
            edit.runCmd('insertHTML', `${field.value}&nbsp;`)
            edit.focus()
        },
        updateTemplate(name) {
            const selected = this.templates.find(item => item.name === name);

            this.emailObj.subject = selected.subject.interpolate({
                first_name: this.content.first_name
            })

            this.emailObj.body = selected.body.interpolate({
                id: this.content.id,
                name: this.content.first_name || 'new Rebitter',
                first_name: this.content.first_name || '',
                middle_name: this.content.middle_name,
                last_name: this.content.last_name,
                email: this.content.email,
                address: this.content.address,
                shorted_address: this.content.address ? this.content.address.slice(0, 12) + " * * * * *" : '-',
                identity: this.content.identity,
                ecdd: this.content.edcc,
                ref_code: this.content.ref_code,
                reference: this.content.reference,
                registered_at: this.content.registered_at,
            })

            this.emailObj.template = selected.name
            this.emailObj.category = selected.category
        }
    },
    mounted() {
        this.updateTemplate('kyc_incomplete_1')
    },
    components: {},
}
</script>
<style>

</style>
